import React from 'react';
import { AlertTriangle, CircleAlert, X } from 'lucide-react';
import { useCreditAlert } from '../context/CreditAlertContext';

function formatCurrency(value) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return '0';
  return `${Math.max(numericValue, 0).toLocaleString('en-IN', {
    maximumFractionDigits: 2,
  })}`;
}

export default function CreditAlertBanner() {
  const { creditAlert, dismissCreditAlert } = useCreditAlert();
  if (!creditAlert) return null;

  const isCritical = creditAlert.severity === 'critical' || Number(creditAlert.remaining) <= 0;
  const remaining = formatCurrency(creditAlert.remaining);

  return (
    <div className="fixed top-5 left-1/2 z-[120] w-[min(calc(100%_-_2rem),760px)] -translate-x-1/2 px-2">
      <div
        role="alert"
        className={`relative overflow-hidden rounded-2xl border bg-white shadow-2xl shadow-slate-900/10 ${
          isCritical ? 'border-[#C0392B]/30' : 'border-[#D68910]/35'
        }`}
      >
        <div className="flex gap-4 px-5 py-4 pl-6">
          <div
            className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${
              isCritical
                ? 'bg-[#C0392B]/10 text-[#C0392B]'
                : 'bg-[#D68910]/12 text-[#D68910]'
            }`}
          >
            {isCritical ? <CircleAlert size={20} fill="currentColor" /> : <AlertTriangle size={20} />}
          </div>

          <div className="flex-1 min-w-0 pr-8 text-left">
            {isCritical ? (
              <>
                <p className="text-base font-semibold text-slate-950">
                  Your credits are exhausted. All calls are currently paused.
                </p>
                <p className="mt-1 text-sm text-slate-700">
                  You can reach us at contact@techladder.ai or +91 70203 04659.
                </p>
              </>
            ) : (
              <>
                <p className="text-base font-semibold text-slate-950">
                  Your credit balance is low — {remaining} remaining.
                </p>
                <p className="mt-1 text-sm text-slate-700">
                  Calls may stop if balance reaches zero.
                </p>
              </>
            )}

          </div>

          <button
            type="button"
            aria-label="Dismiss credit alert"
            onClick={dismissCreditAlert}
            className="absolute p-2 transition rounded-full right-3 top-3 text-slate-500 hover:bg-slate-100 hover:text-slate-900"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
